var map = {
	"./battery-notify.svg": "3b37",
	"./battery.svg": "87fc",
	"./can.svg": "df44",
	"./e_cigy.svg": "a64b",
	"./glass-bottle.svg": "ec36",
	"./pet.svg": "3b35",
	"./salt.svg": "4c84",
	"./salt_light.svg": "4cb4",
	"./tetrapack.svg": "3fd3",
	"./vape.svg": "0f20",
	"./vape_salt.svg": "34c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9787";